<template>
    <header class="navbar" :class="{ offline: !networkOnLine }">
        <router-link
            :to="{name: 'dashboard'}"
        >
            <img
                alt="rr-logo"
                class="logo"
                src="@/assets/img/rr-logo-horizontal.png"
            />
        </router-link>
        <div class="links">
            <nav class="nav-links">
                <el-dropdown
                    :hide-on-click="false"
                    @command="dropDownCommands($event)"
                >
                    <span class="el-dropdown-link">
                        ☰
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            v-if="isUserAdmin"
                            icon="el-icon-user"
                            command="users"
                        >
                            {{ $t("component.navbar.users") }}
                        </el-dropdown-item>
                        <el-dropdown-item
                            v-if="!isUserAdmin"
                            icon="el-icon-user"
                            command="my_profile"
                        >
                            {{ $t("component.navbar.my_profile") }}
                        </el-dropdown-item>
                        <el-dropdown-item
                            icon="el-icon-message-solid"
                            command="demands"
                        >
                            {{ $t("view.demands.menu_option") }}
                        </el-dropdown-item>

                        <el-dropdown-item
                            icon="el-icon-s-release"
                            divided
                            command="logout"
                        >
                            {{ $t("component.navbar.logout") }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </nav>

            <img
                v-if="isUserLoggedIn && networkOnLine"
                class="user-picture can-hide"
                :src="user.photoURL"
                alt="Avatar"
                @click="$router.push({name: 'profile', params: {id: user.id}})"
            />
        </div>
    </header>
</template>

<script>
import firebase               from "firebase/app";
import {mapGetters, mapState} from "vuex";

export default {
    data: () => (
        {
            activeIndex: null
        }
    ),
    computed: {
        ...mapGetters("authentication", ["isUserLoggedIn", "isUserAdmin", "getUserID"]),
        ...mapState("authentication", ["user"]),
        ...mapState("app", ["networkOnLine", "appTitle", "appShortTitle"])
    },
    mounted() {
        this.activeIndex = this.$route.name;
    },
    methods : {
        dropDownCommands(command) {
            switch (command) {
                case "logout":
                    this.logout();
                    break;
                case "my_profile":
                    this.$router.push(
                        {
                            name  : "profile",
                            params: {
                                id: this.getUserID
                            }
                        }
                    );

                    break;
                default:
                    this.$router.push(
                        {
                            name: command
                        }
                    );
            }
        },
        async logout() {
            await firebase.auth().signOut();
        }
    }
};
</script>

<style lang="scss">
.bm-burger-button {
    top   : 12px;
    right : 25px !important;
}

.navigation-list {
    list-style : none;
    display    : block;
    margin     : 0;
    padding    : 0;

    li {
        display : block;
    }

    a {
        color           : #FFF;
        text-decoration : none;
        cursor          : pointer;
        transition      : all .22s ease-in-out;

        &:hover {
            color : #E41E2C;
        }
    }
}

.navbar {
    position         : absolute;
    top              : 0;
    left             : 0;
    z-index          : 20;
    right            : 0;
    height           : 61px;
    background-color : #FFF;
    box-sizing       : border-box;
    border-bottom    : 1px solid #EAECEF;
    padding          : 0.7rem 1.5rem;
    line-height      : 2.2rem;

    .logo {
        height       : 38px;
        margin-right : 8px;

        @media all and (max-width : 370px) {
            height : 30px;
        }
    }

    .links {
        padding-left : 1.5rem;
        box-sizing   : border-box;
        white-space  : nowrap;
        font-size    : 0.9rem;
        position     : absolute;
        right        : 1.5rem;
        top          : 0.7rem;
        display      : flex;

        .nav-links {
            display         : flex;
            align-items     : center;
            justify-content : center;

            .nav-item {
                position    : relative;
                display     : inline-block;
                margin-left : 1.5rem;
                line-height : 2.2rem;
            }
        }
    }

    .user-picture {
        max-height    : 32px;
        margin-left   : 1.5rem;
        border-radius : 50%;
        cursor        : pointer;
    }
}

.el-dropdown {
    font-size    : 22px;
    cursor       : pointer;
    margin-right : 10px;
}

.el-dropdown-menu {
    li {
        a {
            text-decoration : none;
            color           : #212121;
        }
    }
}
</style>
